<div id="shipperDetails" class="pr-2" [formGroup]="shipmentForm">
  <div class="secondary-details mb-2">
    <span>{{ 'shipment.shipper.shipperDetails' | translate }}</span>
  </div>
  <div class="row">
    <div class="row" formGroupName="shipperDetails">
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.shipper.companyName' | translate }}</label
        >:
        <em
          *ngIf="shipmentStatus !== 'Manifested'"
          class="bi bi-person-rolodex icon-mat"
          (click)="openAddress('SHIPPER')"
          #tooltip="matTooltip"
          [matTooltip]="'shipment.shipper.selectFromExistingAddress' | translate"></em>
        <input class="form-control" type="text" formControlName="shipperCompanyName" />
        <app-error-component
          [controlName]="shipmentForm.get('shipperDetails').get('shipperCompanyName')">
        </app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.shipper.contactPersonName' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperContactPersonName" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperContactPersonName')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.shipper.addressLine1' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperAddressLine1" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperAddressLine1')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.shipper.addressLine2' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperAddressLine2" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperAddressLine2')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.shipper.addressLine3' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperAddressLine3" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperAddressLine3')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group address">
        <label class="required-field">{{ 'shipment.shipper.countryName' | translate }}: </label>

        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            matInput
            type="text"
            formControlName="shipperCountryName"
            [matAutocomplete]="auto" />

          <mat-autocomplete
            (optionSelected)="selectionChanged($event?.option.value)"
            #auto="matAutocomplete">
            <mat-option *ngFor="let item of shipCountrylist" [value]="item?.name">
              {{ item?.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperCountryName')
          "></app-error-component>
      </div>

      <div class="col-md-6 form-group address">
        <label
          [ngClass]="{
            'required-field': isShipPostalCodeReq === true
          }"
          >{{ 'shipment.shipper.postalCode' | translate }}</label
        >:

        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            specialIsAlphaNumeric
            matInput
            type="text"
            [disabled]=""
            formControlName="shipperPostalCode"
            [matAutocomplete]="autoPostalCode" />

          <mat-autocomplete #autoPostalCode="matAutocomplete">
            <mat-option
              *ngFor="let item of shipCityList"
              (onSelectionChange)="selectionPincodeChanged($event, item)"
              [value]="item?.postalCode">
              {{ item?.postalCode }} <span *ngIf="item?.city">,</span> {{ item?.city }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperPostalCode')
          "></app-error-component>
        <span class="msg" *ngIf="!isShipPostalCodeValid">{{
          'shipment.shipper.invalidPostalCode' | translate
        }}</span>
      </div>

      <div class="col-md-6 form-group address">
        <label class="required-field">{{ 'shipment.shipper.cityName' | translate }}</label
        >:

        <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
          <input
            matInput
            type="text"
            formControlName="shipperCityName"
            [matAutocomplete]="autoCity" />

          <mat-autocomplete #autoCity="matAutocomplete">
            <mat-option
              *ngFor="let item of shipCityList"
              (onSelectionChange)="selectionCityChanged($event, item)"
              [value]="item?.city">
              {{ item?.city }}<span *ngIf="item?.postalCode">,</span> {{ item?.postalCode }}
              <span *ngIf="item?.cityDistrict">,</span> {{ item?.cityDistrict }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperCityName')
          "></app-error-component>
        <span class="msg" *ngIf="!isShipCityValid || !isShipPostalValidated">{{
          'shipment.shipper.invalidCityName' | translate
        }}</span>
      </div>
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.shipper.countryCode' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperCountryCode" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperCountryCode')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.shipper.suburb' | translate }}</label
        >:
        <input class="form-control" type="text" formControlName="shippersuburb" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shippersuburb')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.shipper.provinceCode' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperProvinceCode" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperProvinceCode')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label class="required-field">{{ 'shipment.shipper.phone' | translate }}</label
        >:
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperPhone" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperPhone')
          "></app-error-component>
      </div>
      <div class="col-md-6 form-group">
        <label>{{ 'shipment.shipper.email' | translate }}: </label>
        <input
          specialIsAlphaNumeric
          class="form-control"
          type="text"
          formControlName="shipperEmail" />
        <app-error-component
          [controlName]="
            shipmentForm.get('shipperDetails').get('shipperEmail')
          "></app-error-component>
      </div>
    </div>
  </div>
</div>
